"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _reactContentLoader = _interopRequireDefault(require("react-content-loader"));
var ChainSkeleton = function ChainSkeleton(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactContentLoader["default"], (0, _extends2["default"])({
    speed: 2,
    width: 260,
    height: 65,
    viewBox: "0 0 260 65",
    backgroundColor: "#e6e6e6",
    foregroundColor: "#ffffff",
    uniqueKey: "chain-skeleton"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "30",
    y: "0",
    rx: "3",
    ry: "3",
    width: "170",
    height: "17"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "30",
    y: "24",
    rx: "3",
    ry: "3",
    width: "110",
    height: "10"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "72",
    rx: "3",
    ry: "3",
    width: "380",
    height: "6"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0",
    y: "88",
    rx: "3",
    ry: "3",
    width: "178",
    height: "6"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "9",
    cy: "9",
    r: "9"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "30",
    y: "41",
    rx: "3",
    ry: "3",
    width: "126",
    height: "10"
  }));
};
var _default = exports["default"] = ChainSkeleton;